import React, { useState, useRef, useEffect } from 'react';
import cx from 'classnames';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import '../../../../ui/accordions/Accordion/index.js';
import '../../../../ui/accordions/AccordionSelect/index.js';
import '../../../../ui/badges/Badge/index.js';
import '../../../../ui/badges/BadgeIcon/index.js';
import '../../../../ui/badges/Checked/index.js';
import '../../../../ui/badges/Panel/index.js';
import '../../../../ui/badges/Status/index.js';
import '../../../../ui/badges/Tag/index.js';
import '../../../../ui/buttons/BabyButton/Base.js';
import '../../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../../ui/buttons/Button/index.js';
import '../../../../ui/buttons/CloseButton/index.js';
import '../../../../ui/buttons/DirectionButton/index.js';
import '../../../../ui/buttons/GradientButton/index.js';
import '../../../../ui/buttons/GradientButtonV2/index.js';
import '../../../../ui/buttons/TabButton/index.js';
import '../../../../ui/buttons/TabButtonV2/index.js';
import '../../../../ui/buttons/TimerButton/index.js';
import '../../../../ui/buttons/TimerButtonV2/index.js';
import '../../../../ui/buttons/TimerButtonV3/index.js';
import '../../../../ui/loaders/Loader/index.js';
import '../../../../ui/loaders/ScreenLoader/index.js';
import '../../../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../../../ui/modals/Modal/Modal.js';
import '../../../../ui/modals/Modal/ModalContentWrapper/index.js';
import { Popper } from '../../../../ui/popups/Popper/index.js';
import '../../../../ui/popups/Popup/BasePopup/index.js';
import '../../../../ui/popups/Popup/Thumb/index.js';
import '../../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../../ui/sliders/EmblaCarousel/index.js';
import '../../../../ui/tables/Table/index.js';
import '../../../../ui/tables/Table/TableTd/index.js';
import '../../../../ui/tabs/Tabs/index.js';
import '../../../../ui/tabs/TabsV2/index.js';
import '../../../../ui/texts/CryptoValue/index.js';
import '../../../../ui/texts/AmountValue/index.js';
import '../../../../ui/texts/TitleWithCurrency/index.js';
import '../../../../ui/texts/Text/index.js';
import '../../../../ui/texts/TextNavigation/index.js';
import '../../../../ui/texts/MinValue/index.js';
import '../../../../ui/socials/SocialsList/index.js';
import { useWindowSize } from '../../../../../utils/hooks/useWindowSize.js';
import styles from './index.module.scss.js';

if (typeof gsap.registerPlugin === "function") {
  gsap.registerPlugin(useGSAP);
}
const id = "rewards-dropdown";
const RDWrapper = ({
  isOpen,
  setIsOpen,
  trigger,
  onClose = () => {
  },
  activeTabID,
  defaultTabID,
  className,
  style,
  tabs,
  ...props
}) => {
  const { isMobile, isTablet } = useWindowSize();
  const [step, setStep] = useState(activeTabID);
  const [prevStep, setPrevStep] = useState("");
  const [height, setHeight] = useState("100%");
  const ref = useRef(null);
  const { contextSafe } = useGSAP(
    () => {
      if (!isOpen) return;
      setTimeout(() => {
        const elem = document.querySelectorAll("[data-animate-fade]");
        const dropdown = document.querySelector(`#${id}`);
        gsap.set(elem, {
          opacity: 0,
          translateY: 100
        });
        gsap.set(dropdown, {
          scale: 0,
          top: -300
        });
        gsap.timeline({
          defaults: {
            delay: 0.3,
            duration: 1,
            ease: "power3.out"
          },
          onComplete: () => {
          }
        }).to(dropdown, {
          scale: 1,
          top: 0
        }).to(elem, { translateY: 0, opacity: 1, stagger: 0.1, delay: 0.5 }, 0);
      }, 10);
    },
    { dependencies: [isOpen], revertOnUpdate: true }
  );
  const initRootPanel = contextSafe(() => {
    const rootPanel = document.querySelector('[data-panel-root="true"]');
    if (!rootPanel) return;
    gsap.to(rootPanel, {
      xPercent: 0,
      maxHeight: "10000vh"
    });
  });
  const initNextPanel = contextSafe(() => {
    const activePanel = document.querySelector(`[data-panel-id="${step}"]`);
    if (!activePanel) return;
    const activePanelElems = activePanel.querySelectorAll(
      "[data-animate-fade]"
    );
    gsap.set(activePanel, {
      autoAlpha: 0,
      xPercent: 0
    });
    gsap.set(activePanelElems, {
      autoAlpha: 0,
      xPercent: 100
    });
  });
  const transitionNext = contextSafe(() => {
    const activePanel = document.querySelector(`[data-panel-id="${step}"]`);
    const rootPanel = document.querySelector('[data-panel-root="true"]');
    if (!rootPanel) return;
    if (!activePanel) return;
    const rootPanelElems = rootPanel.querySelectorAll("[data-animate-fade]");
    const activePanelElems = activePanel.querySelectorAll(
      "[data-animate-fade]"
    );
    const pos = Number(activePanel.dataset.position);
    gsap.timeline({
      defaults: {
        duration: 0.5,
        ease: "power3.out"
      },
      onComplete: () => {
      }
    }).to(
      rootPanelElems,
      {
        xPercent: -30,
        opacity: 0,
        stagger: 0.05
      },
      0
    ).to(
      rootPanel,
      {
        maxHeight: "0vh"
      },
      0
    ).to(
      activePanel,
      {
        xPercent: -1 * pos * 100,
        autoAlpha: 1,
        delay: 0.25
      },
      0
    ).to(
      activePanelElems,
      {
        xPercent: 0,
        autoAlpha: 1,
        stagger: 0.05,
        delay: 0.25
      },
      0
    );
  });
  const transitionPrev = contextSafe(() => {
    const panels = Array.from(
      document.querySelectorAll('[data-panel-root="false"]') || []
    ).filter((item) => {
      if (item.childNodes.length) {
        return true;
      }
      return false;
    });
    const rootPanel = document.querySelector('[data-panel-root="true"]');
    if (!rootPanel) return;
    const rootPanelElems = rootPanel.querySelectorAll("[data-animate-fade]");
    const tl = gsap.timeline({
      defaults: {
        duration: 0.8,
        ease: "power3.out"
      },
      onComplete: () => {
      }
    }).to(
      rootPanelElems,
      {
        xPercent: 0,
        opacity: 1,
        stagger: 0.05,
        delay: 0.25
      },
      0
    ).to(
      rootPanel,
      {
        maxHeight: "calc(100vh - 80px - 90px)"
      },
      0
    );
    if (panels.length) {
      const panelElems = panels[0].querySelectorAll("[data-animate-fade]");
      gsap.set(panels[0], {
        autoAlpha: 1
      });
      tl.to(
        panels[0],
        {
          xPercent: -85,
          autoAlpha: 0
        },
        0
      ).to(
        panelElems,
        {
          xPercent: 60,
          autoAlpha: 0,
          stagger: 0.05
        },
        0
      );
    }
  });
  useEffect(() => {
    const prev = step;
    setPrevStep(prev);
    setStep(activeTabID);
  }, [activeTabID]);
  useEffect(() => {
    setTimeout(() => {
      if (step !== defaultTabID) {
        initRootPanel();
        initNextPanel();
        transitionNext();
      } else {
        transitionPrev();
      }
    }, 100);
  }, [step]);
  useEffect(() => {
    if (!ref?.current) return;
    const activePanel = document.querySelector(`[data-panel-id="${step}"]`);
    if (!activePanel) return;
    setHeight(`${activePanel.offsetHeight}px`);
  }, [ref, step]);
  return /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, className), style, ...props }, /* @__PURE__ */ React.createElement(
    Popper,
    {
      id,
      isOpen,
      setIsOpen,
      triggerClassName: styles.trigger,
      options: {
        modifiers: [
          {
            name: "offset",
            options: { offset: [0, isMobile || isTablet ? 5 : 30] }
          }
        ]
      },
      trigger,
      style: {
        overflow: "hidden"
      }
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles["content-wrapper"]),
        style: {
          "--height": height
        },
        ref
      },
      tabs.map((item, i) => /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cx(styles["tab-panel"]),
          key: i,
          "data-panel-id": item.id,
          "data-panel-root": item.isRoot,
          "data-panel-active": item.id === step,
          "data-position": i
        },
        (step === item.id || item.isRoot || item.id === prevStep && step === defaultTabID) && item.content
      ))
    )
  ));
};
RDWrapper.displayName = "RewardsDropdown.RDWrapper";

export { RDWrapper };
//# sourceMappingURL=index.js.map
